import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { InlineSVGModule } from 'ng-inline-svg-2';
import { LandingLayoutComponent } from '../../../layouts/landing-layout/landing-layout.component';
import { ContactUsSectionComponent } from '../../../shared/components/contact-us/contact-us.component';
import { StatisticsSection1Component } from '../../../shared/components/statistics/statistics-section-1/statistics-section-1.component';
import { StatisticSection2Component } from '../../../shared/components/statistics/statistics-section-2/statistics-section-2.component';
import { CompanyLogoComponent } from './components/company-logo/company-logo.component';
import { DownloadAppsComponent } from './components/download-apps/download-apps.component';
import { FeaturesComponent } from './components/features/features.component';
import { JumbotronComponent } from './components/jumbotron/jumbotron.component';
import { OurToolsLayoutComponent } from './components/our-tools/our-tools.component';
import { WhyUsComponent } from './components/why-us/why-us.component';
import { HomePageRoutingModule } from './home-page-routing.module';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { SharedModule } from '../../../shared/shared-module';

@NgModule({
  declarations: [
    HomePageComponent,
    JumbotronComponent,
    CompanyLogoComponent,
    OurToolsLayoutComponent,
    WhyUsComponent,
    FeaturesComponent,
    DownloadAppsComponent,
  ],
  imports: [
    HomePageRoutingModule,
    LandingLayoutComponent,
    ContactUsSectionComponent,

    StatisticSection2Component,
    StatisticsSection1Component,
    SharedModule,
  ],
})
export class HomePageModule {}
